import * as yup from "yup";

export const adminSingleOwnerAddAccountSchema = yup.object().shape({
  accountNumber: yup.string().max(255).required("The field is required."),
  county: yup.string().max(255).required("The field is required."),
  unit: yup.string(),
});
